import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputSelectSF from '../../../widgets/form/InputSelectSF'

const ParentLoanModalUI = ({ context, successMsg, errorList, setErrorList,
  updateMode, submitted,
  onSubmit, onCancelClick,loanList,
  parentLoanId, onParentLoanIdChange, parentLoanIdError, setParentLoanIdError
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Set Parent Loan'
    buttonLabel='Set'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <div className='g_flex_h g_flex_top c_ln_crt'>
      <div className='col'>
        <InputSelectSF type='text' name='parentLoanId' required={true}
          value={parentLoanId} onChange={onParentLoanIdChange} optionList={loanList}
          error={parentLoanIdError} setError={setParentLoanIdError}
        />
      </div>
    </div>
  </ModalFormUI>

export default ParentLoanModalUI
